import React, { useEffect, useState } from "react";
import { Inject } from "@syncfusion/ej2-react-schedule";
import {
  CheckBoxSelection,
  MultiSelectComponent,
} from "@syncfusion/ej2-react-dropdowns";
import ScheduleView from "./ScheduleView";

const CALENDAR_TITLE = "Calendar";
const CALENDAR_READONLY_TEXT =
  "(This is a read-only calendar for accessing existing meetings only)";

const CalendarView = ({
  colorPalette,
  AllUsers,
  CompanyProfileID,
  selectLoggedInUser = false,
  userProfile,
}) => {
  const [AllHosts, setAllHosts] = useState([]);
  const [AllHostIDs, setAllHostIDs] = useState([]);
  const [SelectedHosts, setSelectedHosts] = useState([]);
  const [ResourceData, setResourceData] = useState([]);

  useEffect(() => {
    var HostOnlyList = AllUsers.filter((user) => user.Role !== "Receptionist");
    var selectedHostList = [];
    var HostList = [];
    var ColorResource = [];
    HostOnlyList.forEach(function (user, index) {
      if (selectLoggedInUser) {
        if (userProfile && userProfile.ProfileID === user.ProfileID) {
          selectedHostList.push(user.ID);
        }
      } else if (index === 0) {
        selectedHostList.push(user.ID);
      }

      HostList.push({
        Id: user.ID,
        Name: user.Profile.FirstName + " " + user.Profile.LastName,
        Color: colorPalette[index],
        OrderID: user.OrderID
      });
      ColorResource.push({
        Id: user.ID,
        Text: user.Profile.FirstName + " " + user.Profile.LastName,
        Color: colorPalette[index],
      });
    });
    setAllHosts(HostList);
    setAllHostIDs(selectedHostList);
    setResourceData(ColorResource);
    setSelectedHosts(selectedHostList);
  }, [AllUsers, colorPalette, userProfile, selectLoggedInUser]);

  const HostSelectionChange = (hostIds) => {
    if (AllHosts.length > 0) {
      const hostList = hostIds
        .map((hostId) => {
          return AllHosts.find((r) => r !== undefined && r.Id === hostId);
        })
        .map((host) => host.Id);

      setSelectedHosts(hostList);
    }
  };

  return (
    <div>
      <h2 className="calendar-title">{CALENDAR_TITLE} </h2>
      <span className="calendar-readonly-label">{CALENDAR_READONLY_TEXT} </span>
      <div className="mb-3 d-flex justify-content-end">
        {AllHosts.length > 0 && AllHostIDs.length > 0 && (
          <HostSelectList
            Hosts={AllHosts}
            AllHostIDs={AllHostIDs}
            colorPalette={colorPalette}
            onSelectChange={HostSelectionChange}
            key={AllHostIDs} /* Force component to re-render */
          />
        )}
      </div>
      {ResourceData.length > 0 && (
        <ScheduleView
          ResourceData={ResourceData}
          hosts={AllHosts}
          SelectedHosts={SelectedHosts}
          CompanyProfileID={CompanyProfileID}
          userProfile={userProfile}
        />
      )}
    </div>
  );
};

export default CalendarView;
/*  ListViewComponent: 
  - https://ej2.syncfusion.com/react/documentation/listview/how-to/get-selected-items-from-listview/
  - https://ej2.syncfusion.com/react/documentation/api/drop-down-button#target
  - https://www.syncfusion.com/forums/147074 how-to-add-filtering-of-schedule-data-based-on-user-selection
  - https://stackblitz.com/edit/react-eb2oys-y4meb1?file=index.js */

const hostListItemTemplate = (data) => {
  return (
    <span
      style={{
        position: "absolute",
        top: "0",
        marginLeft: "10px",
        color: data.Color,
        fontWeight: "bold",
      }}
    >
      <span
        style={{
          display: "none",
          backgroundColor: data.Color,
          height: "20px",
          width: "20px",
          marginRight: "8px",
          lineHeight: 1,
        }}
      ></span>
      <span className="name">{data.Name}</span>
    </span>
  );
};
const HostSelectList = ({ Hosts, AllHostIDs, onSelectChange }) => {
  const onChange = (args) => {
    if (onSelectChange) {
      onSelectChange(args.value);
    }
  };

  return (
    <div>
      <MultiSelectComponent
        dataSource={Hosts}
        value={AllHostIDs}
        fields={{ text: "Name", value: "Id" }}
        placeholder="View Hosts"
        mode="CheckBox"
        showSelectAll={false}
        showDropDownIcon={true}
        showClearButton={false}
        changeOnBlur={false}
        itemTemplate={hostListItemTemplate}
        width="280px"
        change={onChange}
      >
        <Inject services={[CheckBoxSelection]} />
      </MultiSelectComponent>
    </div>
  );
};
